(function(){
  'use strict';
  if(window.__PROFIND_ARIA_HUMAN_SUPPORT_ROUTER_V2)return;
  window.__PROFIND_ARIA_HUMAN_SUPPORT_ROUTER_V2=true;

  var nativeFetch=window.fetch.bind(window);
  var HANDOFF_KEY='profind_aria_human_support_handoff_v2';
  var autoOpenSupportForm=false;

  function normalise(v){
    return String(v||'').toLowerCase().replace(/[’']/g,'').replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();
  }

  function humanSupportIntent(message){
    var q=normalise(message);
    if(!q)return false;
    if(/\b(?:what is|what does|how does|how do|explain|tell me about)\b.{0,35}\b(?:human support|support escalation|support team|support request)\b/.test(q))return false;
    return /\b(?:speak|talk|chat)\s+(?:to|with)\s+(?:a\s+)?(?:human|person|agent|support|support team|someone)\b/.test(q)
      || /\b(?:human|live)\s+(?:support|agent)\b/.test(q)
      || /\b(?:support agent|support team|real person|real human)\b/.test(q)
      || /\b(?:can i|could i|may i|i want to|i need to|please)\b.{0,30}\b(?:speak|talk|contact|reach)\b.{0,30}\b(?:support|someone|a person|a human|an agent)\b/.test(q)
      || /\b(?:get|connect|put)\s+me\s+(?:to|with)\s+(?:support|a human|a person|an agent)\b/.test(q);
  }

  function internalInstructionLeak(message){
    var s=String(message||'');
    return /\bif\s+(?:a\s+|the\s+)?(?:signed[- ]in\s+)?user\b/i.test(s)
      || /\broute\s+(?:them|the user|users?)\b/i.test(s)
      || /\bdo\s+not\s+make\s+(?:them|the user|users?)\b/i.test(s)
      || /\bonly\s+explain\b/i.test(s)
      || /\btypical customer wording\b/i.test(s)
      || /\b(?:system|developer|internal)\s+(?:prompt|instruction|rule)s?\b/i.test(s)
      || /\bARIA\s+(?:must|should|never|checks)\b/i.test(s)
      || /\bdo\s+not\s+expose\b/i.test(s);
  }

  function jsonResponse(payload,status){
    return new Response(JSON.stringify(payload),{
      status:status||200,
      headers:{'Content-Type':'application/json; charset=utf-8','Cache-Control':'no-store'}
    });
  }

  function parseBody(input,init){
    if(init&&typeof init.body==='string'){
      try{return Promise.resolve(JSON.parse(init.body));}catch(_e){return Promise.resolve(null);}
    }
    if(input&&typeof Request!=='undefined'&&input instanceof Request){
      try{return input.clone().json().catch(function(){return null;});}catch(_e2){}
    }
    return Promise.resolve(null);
  }

  function cloneInit(init,body){
    var next={};
    if(init)Object.keys(init).forEach(function(k){next[k]=init[k];});
    next.method='POST';
    next.body=JSON.stringify(body||{});
    return next;
  }

  function rememberHandoff(){
    try{sessionStorage.setItem(HANDOFF_KEY,'1');}catch(_e){}
  }

  function clearHandoff(){
    try{sessionStorage.removeItem(HANDOFF_KEY);}catch(_e){}
  }

  function hasHandoff(){
    try{return sessionStorage.getItem(HANDOFF_KEY)==='1';}catch(_e){return false;}
  }

  async function cleanAriaResponse(resp){
    if(!resp||!resp.clone)return resp;
    var data;
    try{data=await resp.clone().json();}catch(_e){return resp;}
    if(!data||!internalInstructionLeak(data.message))return resp;
    data.message='I can help with that. I’ll keep the answer customer-facing and won’t expose internal ProFind support instructions. Please continue with your ProFind question.';
    data.intent='SAFE_OUTPUT_GUARD';
    data.confidence='LIMITED';
    data.resolution='CONTINUE';
    data.suggestions=[];
    return jsonResponse(data,resp.status||200);
  }

  async function routePrivateHumanSupport(url,input,init,body){
    var first=await nativeFetch(input,init);
    if(!first.ok)return first;
    var firstData;
    try{firstData=await first.clone().json();}catch(_e){return first;}
    if(!firstData||!firstData.conversation_id)return cleanAriaResponse(first);

    var finalData=firstData;
    if(firstData.can_escalate!==true){
      var secondBody={};
      Object.keys(body||{}).forEach(function(k){secondBody[k]=body[k];});
      secondBody.action='MESSAGE';
      secondBody.message='I still need human ProFind Support.';
      secondBody.conversation_id=firstData.conversation_id;
      var second=await nativeFetch(url,cloneInit(init,secondBody));
      if(second.ok){
        try{finalData=await second.clone().json();}catch(_e2){finalData=firstData;}
      }
    }

    autoOpenSupportForm=true;
    return jsonResponse({
      conversation_id:finalData.conversation_id||firstData.conversation_id,
      account_type:finalData.account_type||body.account_type||'PERSONAL',
      message:'Of course. I can connect you with ProFind Support. Complete the short support request below and you’ll receive a case reference you can track under My Support Requests.',
      intent:'HUMAN_SUPPORT_REQUEST',
      confidence:'HIGH',
      resolution:'CONTINUE',
      actions:[],
      suggestions:[],
      can_escalate:finalData.can_escalate===true,
      escalation:{category:'Other',feature:'Support',priority:'NORMAL',response_time:'normally within 3 working days'},
      support_engine:'HUMAN_SUPPORT_ROUTER_V2',
      diagnostics:[],
      known_issues:[]
    },200);
  }

  window.fetch=async function(input,init){
    var url=typeof input==='string'?input:(input&&input.url?input.url:'');
    var isPublic=url.indexOf('/functions/v1/aria-public-support')!==-1;
    var isPrivate=url.indexOf('/functions/v1/aria-support')!==-1 && url.indexOf('/functions/v1/aria-support-ticket')===-1 && url.indexOf('/functions/v1/aria-support-upload')===-1;

    if(isPublic||isPrivate){
      var body=await parseBody(input,init);
      var message=body&&(body.message||body.question||body.query||'');
      if(humanSupportIntent(message)){
        if(isPublic){
          rememberHandoff();
          return jsonResponse({
            message:'Of course. You can reach a person at ProFind Support by emailing support@profind.co.za — normal support requests are responded to within 3 working days. If you have a ProFind account, choose Personal or Business login below and I’ll take you straight to the support request flow. If you’d like the ProFind team to contact you by email about listing your business, tap “Have ProFind email me”.',
            intent:'HUMAN_SUPPORT_REQUEST',
            confidence:'HIGH',
            resolution:'CONTINUE',
            action_keys:['EMAIL_SUPPORT','LEAD_CAPTURE','PERSONAL_LOGIN','BUSINESS_LOGIN'],
            lead_capture:{auto_open:false,consent_text:'I agree that ProFind may store these details and contact me by email about listing my business. See our Privacy Policy.',privacy_url:'/policies/privacy-policy'},
            suggestions:[],
            public:true,
            support_engine:'HUMAN_SUPPORT_ROUTER_V2'
          },200);
        }
        return routePrivateHumanSupport(url,input,init,body||{});
      }

      var response=await nativeFetch(input,init);
      return cleanAriaResponse(response);
    }

    return nativeFetch(input,init);
  };

  var formObserver=new MutationObserver(function(){
    if(!autoOpenSupportForm)return;
    var block=document.querySelector('#pf-aria-root [data-aria-escalate]');
    if(!block)return;
    var button=block.querySelector('button');
    if(!button)return;
    autoOpenSupportForm=false;
    try{button.click();}catch(_e){}
    block.style.display='none';
  });
  formObserver.observe(document.documentElement,{childList:true,subtree:true});

  function resumeAfterLogin(){
    if(!hasHandoff())return;
    if(!document.getElementById('pfx-root')&&!document.getElementById('pfbo2-root'))return;
    var tries=0,timer=setInterval(function(){
      tries++;
      if(window.ProFindARIA&&typeof window.ProFindARIA.ask==='function'){
        clearInterval(timer);
        clearHandoff();
        window.ProFindARIA.ask('I want to speak to ProFind Support');
      }else if(tries>80){
        clearInterval(timer);
      }
    },100);
  }

  var current=document.currentScript;
  var core=document.createElement('script');
  core.async=false;
  core.defer=true;
  core.src=current&&current.src?new URL('profind-aria-support-core.js?v=pf20261022-loginfix1',current.src).href:'/cdn/shop/t/1/assets/profind-aria-support-core.js';
  core.setAttribute('data-profind-aria-core','true');
  core.addEventListener('load',function(){setTimeout(resumeAfterLogin,60);});
  (current&&current.parentNode?current.parentNode:document.body).appendChild(core);
})();